<div class="responsive-container">
<bpc-generic-listing [tableClass]="'elevation-table'" [title]="'Elevations'" [columns]="companiesColumns" [barType]="HorizontalBar" [companiesFilter]="companiesFilter" [hasPod]="false" [data]="companies" [totalCount]="totalCount" [isLoading]="isLoading" (onFilterChange)="onFilterChange($event)" (onLoadMore)="loadMoreData()">
      <div slot="subroutes" class="col flex align-content-center flex-wrap flex-w-auto vote-tab-container">
        <ng-container *ngFor="let ef of childTabs" >
          <a  *ngIf="!ef.disabled"
              class="vote-tab-buttons {{ef.class}}" 
              [routerLink]="!isMobile ? '/elevations/' + ef.route : '/m/elevations/' + ef.route" 
              [ngClass]="{ 'active-ic-vote-tab': type === ef.route }">
            {{ ef.label }}
          </a>
        </ng-container>
      </div>
  </bpc-generic-listing>
</div>
